var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dol-sign-box",class:_vm.className},[_c('canvas',{ref:"canvas",staticStyle:{"margin":"0","padding":"0"},attrs:{"width":_vm.width,"height":_vm.height},on:{"touchstart":_vm.touchStart,"touchmove":_vm.touchMove,"touchend":_vm.touchEnd,"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"mouseup":_vm.mouseUp}})])
}
var staticRenderFns = []

export { render, staticRenderFns }